import { render, staticRenderFns } from "./WidgetNavigationBox.vue?vue&type=template&id=7df4eb38&scoped=true&"
import script from "./WidgetNavigationBox.vue?vue&type=script&lang=js&"
export * from "./WidgetNavigationBox.vue?vue&type=script&lang=js&"
import style0 from "./WidgetNavigationBox.vue?vue&type=style&index=0&id=7df4eb38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4eb38",
  null
  
)

export default component.exports